import { VoucherRedemptionStepsResponse } from './models';
import { createQuery } from '../../libs';

const url = 'voucher-redemption-steps';

export const useGetVoucherRedemptionSteps = createQuery<
  VoucherRedemptionStepsResponse,
  unknown
>(
  {
    method: 'get',
    url: `${url}`,
  },
  {
    staleTime: 0,
    keepPreviousData: false,
  }
);
